import React, { Component } from 'react'
import pimiento from "./../../assets/img/pimiento.svg";
import pan from "./../../assets/img/pan.svg";
import palta from "./../../assets/img/palta.svg"

class LocalesIntGrid extends Component {
  startModal(id) {
    const modal = document.getElementById(id);
    modal.classList.add('is-active');
  }

  closeModal(id) {
    const modal = document.getElementById(id);
    modal.classList.remove('is-active');
  }

  item(el) {
    return (
      <div key={el.id} id={`local-int${el.id}`} className="column is-half-tablet is-half-desktop is-one-third-widescreen grid-item">

        <div className="grid-item-info">
          <div className="header-tanta-mundo">
            <h4>{el.grid_locales_titulo_int}</h4>
            <ul className="mundo-iconos">
              <li><i className="fa fa-map-marker" onClick={() => { this.startModal(`map-int${el.id}`) }}></i></li>
              <li><a href={el.facebook}><i className="fa fa-facebook"></i></a></li>
            </ul>
          </div>
          <div className="content-info">
            <p>
              <span>{ el.grid_locales_direccion_int }</span>
              <span>{ el.grid_locales_horario_int }</span>
              <span><a href={el.grid_locales_web_int}>{el.grid_locales_nombre_web_int}</a></span>
              <span>Teléfono: {el.grid_locales_telefono_int}</span>
            </p>
          </div>  
        </div>

        <div id={`map-int${el.id}`} className="modal">
          <div className="modal-background" onClick={() => { this.closeModal(`map-int${el.id}`) }}></div>
          <div className="modal-content">
            <h3>{el.grid_locales_titulo_int}</h3>
            <iframe title={el.id} frameBorder="0" src={el.grid_locales_ubicacion_int}></iframe>
          </div>
          <button className="modal-close" onClick={() => { this.closeModal(`map-int${el.id}`) }}></button>
        </div>

      </div>
    )
  }

  gridItems() {
    return this.props.apiHome.grid_locales_int ? this.props.apiHome.grid_locales_int.map(el => this.item(el)) : '';
  }

  render() {
    return (
      <section id="js-int-grid" className="section tanta-mundo-grid"
        data-aos="fade" data-aos-duration="650" data-aos-delay="360" data-aos-offset="160" data-aos-easing="ease-in-out-quad">
        
        <img className="pimiento" src={pimiento} alt="" />
        <img className="pan" src={pan} alt="" />
        <img className="palta" src={palta} alt="" />

        <div className="container">
          <div className="columns">
            <div className="column is-10 is-offset-1">
              <div className="columns is-multiline">

                {this.gridItems()}

              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default LocalesIntGrid;
